
<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable>
    <template v-if="!hideButton" v-slot:activator="{ props }">
      <v-btn
             color="primary"
             :class="{ 'float-right': floatRight }"
             v-bind="props"><v-icon class="mr-2">mdi-plus</v-icon>Baixa manual</v-btn>
    </template>
    <v-card>
      <v-toolbar color="primary" title="Baixa manual">
        <v-btn color="black" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <FormWriteOff
                      :user="user"
                      v-model="value"
                      @created="createdObject"
                      @complete="closeDialog" />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" color="error" @click="dialog = false">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import FormInvoice from "./FormInvoice.vue";
import FormWriteOff from "./FormWriteOff.vue";
export default {
  components: { FormInvoice, FormWriteOff },
  props: {
    user: Object,
    modelValue: Object,
    floatRight: Boolean,
    hideButton: Boolean,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      dialog: false,
    };
  },
  mounted() { },
  activated() { },
  methods: {
    createdObject(val) {
      this.dialog = false;
      this.$emit("created", val);
    },
    closeDialog() {
      this.dialog = false;
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (newVal && !this.dialog) {
        this.dialog = true;
      }
    },
    // dialog(newVal) {
    //   if (!newVal) {
    //     this.value = {};
    //   }
    // },
  },
};
</script>
